var map = {
	"./client/en-US.json": [
		98458,
		8458
	],
	"./client/es-419.json": [
		99227,
		9227
	],
	"./client/ja.json": [
		93317,
		3317
	],
	"./client/pt-BR.json": [
		7583,
		7583
	],
	"./client/th.json": [
		21488,
		1488
	],
	"./client/zh-CN.json": [
		33664,
		3664
	],
	"./client/zh-TW.json": [
		7960,
		7960
	],
	"./editor/en-US.json": [
		10972,
		972
	],
	"./editor/es-419.json": [
		79373,
		9373
	],
	"./editor/ja.json": [
		74679,
		4679
	],
	"./editor/pt-BR.json": [
		41553,
		1553
	],
	"./editor/th.json": [
		13062,
		3062
	],
	"./editor/zh-CN.json": [
		87294,
		7294
	],
	"./editor/zh-TW.json": [
		79626,
		9626
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 19169;
module.exports = webpackAsyncContext;